export default "__VITE_ASSET__uw6VcQGu__"